import { render, staticRenderFns } from "./DepurationModal.vue?vue&type=template&id=2f1ac1ab&scoped=true"
import script from "./DepurationModal.vue?vue&type=script&lang=js"
export * from "./DepurationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ac1ab",
  null
  
)

export default component.exports